import { breakpoints, customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightsListSectionRoot = styled.div`
  height: 100%;
  overflow: hidden;
  border-right: 2px solid var(--border-soft);

  @media ${breakpoints['max-lg']} {
    overflow: auto;
    ${customScrollMinimal};
  }
`;

export const Wrapper = styled.div`
  padding: 0 20px;
`;
